export const firebaseConfig = {
  apiKey: "AIzaSyAQBIVAmQEVFrZO0JxJyrqlMRcXEp1gpsY",
  authDomain: "jerusalem-temple.firebaseapp.com",
  databaseURL: "https://jerusalem-temple.firebaseio.com",
  projectId: "jerusalem-temple",
  storageBucket: "jerusalem-temple.appspot.com",
  messagingSenderId: "716356656075"
};


// WEBPACK FOOTER //
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/environments/firebase.config.ts